import { generic } 		from './modules/generic'
import { nav } 			from './modules/nav'
import { scroll } 		from './modules/scroll'
import { slider }		from './modules/slider'
import { rellax } 		from './modules/rellax'
import { counter } 		from './modules/counter'
import { accordion } 	from './modules/accordion'

window.onload = function () {
	generic()
	nav()
	scroll()
	slider()
	rellax()
	counter()
	accordion()

	document.querySelectorAll('.button--pins').forEach((item) => {
		item.addEventListener('click', togglePins)
	})

	function togglePins() {
		this.classList.toggle('button--focus')

		document.querySelectorAll('.' + this.id).forEach((item) => {
			item.classList.toggle('hide')
		})
	}
}
